<app-header></app-header>
<ion-content>
  <!----Pull down refresher--->
  <ng-container
    *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
  >
    <ion-refresher
      slot="fixed"
      [pullFactor]="1"
      [pullMin]="50"
      [pullMax]="900"
      (ionRefresh)="handleRefresh($event)"
      *appShowSplit="[orderDetailsPageRefresherFlag]"
    >
      <ion-refresher-content
        pullingIcon="chevron-down"
        pullingText=""
        refreshingSpinner="circles"
        refreshingText=""
      >
      </ion-refresher-content>
    </ion-refresher>
  </ng-container>

  <!------------Desktop---------->
  <div
    id="desktop"
    *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
  >
    <div class="top-section-background">
      <ion-grid [fixed]="true">
        <div class="header-section">
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </div>
        <div class="order-info-section">
          <app-submitted-order-info-card
            [products]="submittedOrderVm?.products"
            [isOnline$]="panAppState.online$"
            [displayTitle]="submittedOrderVm?.displayTitle"
            [orderHeader]="submittedOrderVm?.submittedOrderById?.orderHeader"
            [orderItems]="submittedOrderVm?.submittedOrderById?.orderItems"
            [tallies]="submittedOrderVm?.tallies"
            [customer]="customer$ | async"
            [orderStatusDetails]="orderStatusDetails"
            [deliveryETA]="deliveryETA"
            [actualDeliveryDate]="actualDeliveryDate"
            [isDelivered]="!!submittedOrderVm?.submittedOrderById?.orderHeader
            ?.orderDelivered"
            [isInternalUser]="isInternalUser"
            [restrictToOG]="submittedOrderVm?.restrictToOG"
            [isDealsAvailable]="isDealsAvailable"
            [willCallInFlight]="willCallInFlight$ | async"
            [customerTimeZone]="this.customerTimeZone"
            [autoSubItems]="submittedOrderVm?.autoSubItems"
            [isEditable]="submittedOrderVm?.isEditable"
            [isCancellable]="submittedOrderVm?.isCancellable"
            [shipToCustomer]="submittedOrderVm?.shipToCustomer || (superUserShipToCustomer$ | async)"
            [shipToInFlight]="shipToInFlight$ | async"
            [shipToDepartmentName]="submittedOrderVm?.shipToDepartmentName || getShipToDepartmentName((superUserShipToCustomer$ | async), submittedOrderVm?.submittedOrderById?.orderHeader?.shipToDepartment) "
            (downloadModalOpenEmitter)="showDownloadOrderModal(true)"
            (downloadFileEmmitter)="handleDownloadOrder($event)"
            (printOrderEmitter)="printOrderEmitterHandler()"
            (shareOrderEmitter)="shareOrderEmitterHandler()"
            (editSubmittedOrderEmitter)="editSubmittedOrder()"
            (transferModalEmitter)="transferModal()"
            (cancelOrderModalEmitter)="cancelOrderModal()"
            (shipToModalOpenEmitter)="showShipToModal(true)"
            (willCallModalOpenEmitter)="openWillCallModal()"
            (recoveryModalOpenEmitter)="showRecoveryModal(true)"
            [platformType]="platformService?.platformEnum.desktop"
            [showTransferButton]="submittedOrderVm?.showTransferButton"
            [transferButtonText]="submittedOrderVm?.transferButtonText"
            [modifyButtonText]="submittedOrderVm?.modifyButtonText"
            [orderStatusDisplayEnabled]="submittedOrderVm?.orderStatusDisplayEnabled"
            [customersWithTheSameDivision]="submittedOrderVm?.customersWithTheSameDivision"
            [isProntoDeliveryCustomer]="isProntoDeliveryDate || isSuperUserProntoCustomer"
          ></app-submitted-order-info-card>
        </div>

        <!------- Start: Google map Desktop ------->
        <div
          [hidden]="!orderHasDeliveryDetails"
          *ngIf="((!submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered && submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered !== null) &&
                        isAllCoordinatesValid && submittedOrderVm?.submittedOrderById?.orderHeader?.etaMessageType === orderETAMessageType.ETA) &&
                        !(hideEtaGlobalFeatureFlag && submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta)"
        >
          <div data-cy="wmt-desktop-map-section" #map class="map"></div>
          <div data-cy="wmt-desktop-disclosure-text" class="note-map">
            {{ 'i18n.orderPage.WMTnote' | translate }}
          </div>
        </div>
        <!------- /End: Google map ------->
      </ion-grid>
    </div>
    <div class="bottom-section-background">
      <ion-grid [fixed]="true">
        <ion-row>
          <ion-col
            size-xl="12"
            size-l="12"
            size-md="12"
            size-s="12"
            size-xs="12"
          >
            <app-deals-banner
              [bannerStyle]="bannerStyle"
              [buttonLink]="dealsUrl"
            >
            </app-deals-banner>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-grid [fixed]="true">
        <ion-row>
          <ion-col
            *ngIf="platformService?.platformType !==
                  platformService?.platformEnum?.mobile &&
                  isDealsAvailable"
            size-xl="12"
            size-l="12"
            size-md="12"
            size-s="12"
            size-xs="12"
          >
            <ion-item class="banner-note">
              <ion-label data-cy="order-details-deals-note-text">
                <span class="note-bold" data-cy="submitted-order-note-label"
                  >{{ 'i18n.common.note' | translate }}</span
                >
                <span class="note-regular" data-cy="submitted-order-note-text">
                  {{ 'i18n.confirmationPage.dealsNoteOnDetails' | translate }}
                </span>
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
        <div
          data-cy="order-details-search-sort-filter-section"
          class="search-sort-filter-section"
          *appShowSplit="[orderDetailsSearchFeatureFlag]"
        >
          <div class="search-container">
            <ion-searchbar
              id="list-search-bar-0"
              data-cy="list-detail-searchbar"
              class="search"
              mode="md"
              placeholder="{{ 'i18n.orderSubmittedPage.searchWithinOrder' | translate}}"
              [ngModel]="searchKey | async"
              (ionInput)="orderItemSearch($event)"
            >
            </ion-searchbar>
          </div>
          <div>
            <div
              *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader.orderType !== 'VS'"
            >
              <ion-button
                data-cy="sort-filter-button"
                class="usf-outline-green-button sort-button"
                (click)="showSortModal(true)"
              >
                <ion-icon
                  data-cy="sort-filter-button-icon"
                  slot="start"
                  name="filter"
                ></ion-icon>
                <span data-cy="sort-filter-button-text">
                  {{ 'i18n.lists.sortAndFilter' | translate }}
                  <span *ngIf="sortFilterCount > 0" data-cy="sort-filter-count"
                    >({{ sortFilterCount }})</span
                  >
                </span>
              </ion-button>
              <ion-button
                class="usf-green-link-button"
                (click)="clearReservedSort()"
              >
                {{ 'i18n.common.clearAll' | translate }}
              </ion-button>
            </div>
          </div>
        </div>

        <!-- Autosubbed products -->
        <ion-row *ngIf="substituteProducts?.length > 0">
          <ng-container>
            <ion-col
              size-xl="12"
              size-l="12"
              size-md="12"
              size-s="12"
              size-xs="12"
            >
              <div class="submitted-order-title">
                <h2 data-cy="submitted-order-title-text">
                  {{ 'i18n.orderSubmittedPage.autoSubDetails' | translate }}
                </h2>
              </div>
            </ion-col>
          </ng-container>
          <ion-col
            size-xl="12"
            size-l="12"
            size-md="12"
            size-s="12"
            size-xs="12"
          >
            <div
              *ngFor="let item of substituteProducts; last as lastItem; index as i;"
            >
              <app-order-submitted-item-card
                [item]="item"
                [subbedItem]="item.substituteFlag === 'A' ? autoSubItem(item?.substituteFor) : null"
                [productSummary]="submittedOrderVm.products?.get(item?.productNumber)?.summary"
                [subbedProductSummary]="submittedOrderVm.autoSubItems?.get(item?.substituteFor)?.productSummary"
                [lastItem]="lastItem"
                [displayTags]="submittedOrderVm.displayTags?.get(item?.productNumber)"
                [availableToPromise]="submittedOrderVm?.showAvailableToPromise"
              ></app-order-submitted-item-card>
            </div>
          </ion-col>
        </ion-row>

        <!-- Order products -->
        <ion-row>
          <ng-container>
            <ion-col
              size-xl="12"
              size-l="12"
              size-md="12"
              size-s="12"
              size-xs="12"
            >
              <div
                *ngIf="filteredOrderItems$ | async as filteredOrderItems"
                class="submitted-order-title"
              >
                <h2 data-cy="submitted-order-title-text">
                  {{filteredOrderItems?.length}} {{
                  'i18n.orderSubmittedPage.product' | translate }}{{
                  filteredOrderItems?.length === 1 ? '' : 's' }}
                </h2>
              </div>
            </ion-col>
          </ng-container>
          <ion-col
            size-xl="12"
            size-l="12"
            size-md="12"
            size-s="12"
            size-xs="12"
          >
            <!-- Vendor ship order items -->

            <ng-container
              *ngIf="submittedOrderVm?.submittedOrderById?.orderItems && submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'VS' && orderTrackingGroups$ | async as orderTrackingGroups"
            >
              <ion-accordion-group
                *ngFor="let trackingGroup of orderTrackingGroups | keyvalue"
                (ionChange)="accordionGroupChange($event, trackingGroup.key)"
                value="accordionRow"
              >
                <ion-accordion value="accordionRow">
                  <ion-item
                    slot="header"
                    id="no-ripple"
                    class="gray-content-bg"
                  >
                    <div class="expandable-panel-header">
                      <div
                        class="expandable-panel-header-label"
                        data-cy="order-submitted-estimated-delivery-label"
                      >
                        {{ 'i18n.orderSubmittedPage.estimatedDelivery' |
                        translate }}
                        <span data-cy="submitted-order-estimated-delivery-text"
                          >{{
                          submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus
                          === orderStatusEnum.ORDER_CANCELLED ? "N/A" :
                          orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.estimatedDeliveryDate
                          ?
                          (orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.estimatedDeliveryDate
                          | date: "MM/dd/yyyy") :
                          'i18n.orderSubmittedPage.comingSoon' | translate
                          }}</span
                        >
                      </div>

                      <div
                        class="expandable-panel-header-label"
                        data-cy="order-submitted-carrier-label"
                      >
                        {{ 'i18n.orderSubmittedPage.carrier' | translate }}
                        <span data-cy="submitted-order-tracking-code-text"
                          >{{
                          submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus
                          === orderStatusEnum.ORDER_CANCELLED ? "N/A" : (
                          orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode
                          === 'FEDEX' ? 'FedEx' : (
                          (orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode
                          === '' ||
                          !orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode)
                          ? (!trackingGroup.key ?
                          ('i18n.orderSubmittedPage.comingSoon' | translate) :
                          'N/A') :
                          orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode
                          ) ) }}</span
                        >
                      </div>
                      <div
                        data-cy="wmt-open-tracking-info-link"
                        class="expandable-panel-header-label"
                      >
                        {{ 'i18n.orderSubmittedPage.tracking' | translate }}
                        <a
                          [ngClass]="{'tracking-link': submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED, 'cancelled-tracking': submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus === orderStatusEnum.ORDER_CANCELLED}"
                          *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED && orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode && orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode !== ''"
                          (click)="$event.stopPropagation(); openTrackingInfo({ trackingNumber: trackingGroup.key, carrierCode: orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode})"
                          >{{ trackingGroup.key ? trackingGroup.key : '' }}
                          <ion-icon
                            *ngIf="trackingGroup.key"
                            src="assets/icon/external-link.svg"
                          ></ion-icon
                        ></a>
                        <span
                          *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus === orderStatusEnum.ORDER_CANCELLED"
                          data-cy="order-submitted-cancelled-tracking"
                          >N/A</span
                        >
                        <span
                          *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED && (!orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode || orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode === '')"
                          data-cy="order-submitted-coming-soon-label"
                          >{{ trackingGroup.key ? trackingGroup.key :
                          ('i18n.orderSubmittedPage.comingSoon' | translate)
                          }}</span
                        >
                      </div>
                    </div>
                  </ion-item>
                  <div slot="content">
                    <ng-container
                      *ngIf="orderTrackingGroups[trackingGroup.key]?.length > 0; else noResultsFound"
                    >
                      <div
                        *ngFor="let trackingItem of orderTrackingGroups[trackingGroup.key]; last as lastItem; index as i"
                      >
                        <app-order-submitted-item-card
                          [item]="trackingItem?.orderItem"
                          [productSummary]="submittedOrderVm?.products?.get(trackingItem?.orderItem?.productNumber)?.summary"
                          [lastItem]="lastItem"
                          [displayTags]="submittedOrderVm?.displayTags?.get(trackingItem?.orderItem?.productNumber)"
                          [trackingNumber]="trackingItem?.orderTracking?.trackingNumber?.includes('|') ? trackingItem?.orderTracking?.trackingNumber : null"
                          [carrierCode]="orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode"
                          [availableToPromise]="submittedOrderVm?.showAvailableToPromise"
                          (openTrackingInfo)="openTrackingInfo($event)"
                        ></app-order-submitted-item-card>
                      </div>
                    </ng-container>
                    <ng-template #noResultsFound>
                      <div class="no-result-found-card">
                        <ion-card>
                          <ion-card-content class="no-result-found-text">
                            {{'i18n.orderPage.noProductsWereFound' | translate}}
                          </ion-card-content>
                        </ion-card>
                      </div>
                    </ng-template>
                  </div>
                </ion-accordion>
              </ion-accordion-group>
            </ng-container>
            <!-- Router order items -->
            <div>
              <ng-container
                *ngIf="filteredOrderItems$ | async as filteredOrderItems"
              >
                <ng-container
                  *ngIf="
                (submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'RT' ||
                submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'WC' ||
                submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'CC')"
                >
                  <ng-container
                    *ngIf="filteredOrderItems?.length > 0; else noResultsFound"
                  >
                    <div
                      *ngFor="let item of filteredOrderItems;
                last as lastItem; index as i;"
                    >
                      <app-order-submitted-item-card
                        [item]="item"
                        [productSummary]="submittedOrderVm?.products?.get(item?.productNumber)?.summary"
                        [lastItem]="lastItem"
                        [displayTags]="submittedOrderVm?.displayTags?.get(item?.productNumber)"
                        [availableToPromise]="submittedOrderVm?.showAvailableToPromise"
                      ></app-order-submitted-item-card>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
            <ng-template #noResultsFound>
              <div class="no-result-found-card">
                <ion-card>
                  <ion-card-content class="no-result-found-text">
                    {{'i18n.orderPage.noProductsWereFound' | translate}}
                  </ion-card-content>
                </ion-card>
              </div>
            </ng-template>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <app-footer></app-footer>
  </div>

  <!--Touch Only-->
  <div class="touch" *ngIf="this.platformService?.isTouchExperience$ | async">
    <div id="tablet">
      <div class="top-section-background">
        <ion-grid [fixed]="true">
          <div class="order-info-section">
            <app-submitted-order-info-card
              [products]="submittedOrderVm?.products"
              [isOnline$]="panAppState.online$"
              [displayTitle]="submittedOrderVm?.displayTitle"
              [orderHeader]="submittedOrderVm?.submittedOrderById?.orderHeader"
              [orderItems]="submittedOrderVm?.submittedOrderById?.orderItems"
              [tallies]="submittedOrderVm?.tallies"
              [customer]="customer$ | async"
              [orderStatusDetails]="orderStatusDetails"
              [deliveryETA]="deliveryETA"
              [actualDeliveryDate]="actualDeliveryDate"
              [isDelivered]="!!submittedOrderVm?.submittedOrderById?.orderHeader
              ?.orderDelivered"
              [isInternalUser]="isInternalUser"
              [restrictToOG]="submittedOrderVm?.restrictToOG"
              [isDealsAvailable]="isDealsAvailable"
              [willCallInFlight]="willCallInFlight$ | async"
              [customerTimeZone]="this.customerTimeZone"
              [autoSubItems]="submittedOrderVm?.autoSubItems"
              [isEditable]="submittedOrderVm?.isEditable"
              [isCancellable]="submittedOrderVm?.isCancellable"
              [shipToCustomer]="submittedOrderVm?.shipToCustomer || (superUserShipToCustomer$ | async)  "
              [shipToDepartmentName]="submittedOrderVm?.shipToDepartmentName || getShipToDepartmentName((superUserShipToCustomer$ | async), submittedOrderVm?.submittedOrderById?.orderHeader?.shipToDepartment) "
              [shipToInFlight]="shipToInFlight$ | async"
              (downloadModalOpenEmitter)="showDownloadOrderModal(true)"
              (downloadFileEmmitter)="handleDownloadOrder($event)"
              (printOrderEmitter)="printOrderEmitterHandler()"
              (shareOrderEmitter)="shareOrderEmitterHandler()"
              (editSubmittedOrderEmitter)="editSubmittedOrder()"
              (transferModalEmitter)="transferModal()"
              (cancelOrderModalEmitter)="cancelOrderModal()"
              (shipToModalOpenEmitter)="showShipToModal(true)"
              (willCallModalOpenEmitter)="openWillCallModal()"
              (recoveryModalOpenEmitter)="showRecoveryModal(true)"
              [platformType]="platformService?.platformEnum.tablet"
              [showTransferButton]="submittedOrderVm?.showTransferButton"
              [transferButtonText]="submittedOrderVm?.transferButtonText"
              [modifyButtonText]="submittedOrderVm?.modifyButtonText"
              [orderStatusDisplayEnabled]="submittedOrderVm?.orderStatusDisplayEnabled"
              [customersWithTheSameDivision]="submittedOrderVm?.customersWithTheSameDivision"
              [isProntoDeliveryCustomer]="isProntoDeliveryDate || isSuperUserProntoCustomer"
            ></app-submitted-order-info-card>
          </div>
          <!------- Start: Google map Touch ------->

          <div
            [hidden]="!orderHasDeliveryDetails"
            *ngIf="((!submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered && submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered !== null) &&
                                          isAllCoordinatesValid && submittedOrderVm?.submittedOrderById?.orderHeader?.etaMessageType === orderETAMessageType.ETA) &&
                                          !(hideEtaGlobalFeatureFlag && submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta)"
          >
            <div
              data-cy="wmt-tablet-map-section"
              #map
              class="map"
              *ngIf="this.platformService?.platformType ===  this.platformService?.platformEnum?.tablet"
            ></div>

            <div data-cy="wmt-tablet-disclosure-text" class="note-map">
              {{ 'i18n.orderPage.WMTnote' | translate }}
            </div>
          </div>
          <!------- /End: Google map Touch ------->
        </ion-grid>
      </div>
      <div class="bottom-section-background">
        <ion-grid [fixed]="true">
          <ion-row>
            <ion-col
              size-xl="12"
              size-l="12"
              size-md="12"
              size-s="12"
              size-xs="12"
            >
              <app-deals-banner
                [bannerStyle]="bannerStyle"
                [buttonLink]="dealsUrl"
              >
              </app-deals-banner>
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-grid [fixed]="true">
          <ion-row>
            <ion-col
              *ngIf="platformService?.platformType !==
                  platformService?.platformEnum?.mobile &&
                  isDealsAvailable"
              size-xl="12"
              size-l="12"
              size-md="12"
              size-s="12"
              size-xs="12"
            >
              <ion-item class="banner-note">
                <ion-label data-cy="order-details-deals-note-text">
                  <span class="note-bold" data-cy="submitted-order-note-label"
                    >{{ 'i18n.common.note' | translate }}</span
                  >
                  <span
                    class="note-regular"
                    data-cy="submitted-order-note-text"
                  >
                    {{ 'i18n.confirmationPage.dealsNoteOnDetails' | translate }}
                  </span>
                </ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
          <div
            data-cy="order-details-search-sort-filter-section"
            class="search-sort-filter-section"
            *appShowSplit="[orderDetailsSearchFeatureFlag]"
          >
            <div class="search-container">
              <ion-searchbar
                id="list-search-bar-0"
                data-cy="list-detail-searchbar"
                class="search"
                mode="md"
                placeholder="{{ 'i18n.orderSubmittedPage.searchWithinOrder' | translate}}"
                [ngModel]="searchKey | async"
                (ionInput)="orderItemSearch($event)"
              >
              </ion-searchbar>
            </div>
            <div>
              <div
                *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader.orderType !== 'VS'"
              >
                <ion-button
                  data-cy="sort-filter-button"
                  class="usf-outline-green-button sort-button mobile-width"
                  (click)="showSortModal(true)"
                >
                  <ion-icon
                    data-cy="sort-filter-button-icon"
                    slot="start"
                    name="filter"
                  ></ion-icon>
                  <span data-cy="sort-filter-button-text">
                    {{ 'i18n.lists.sortAndFilter' | translate }}
                    <span
                      *ngIf="sortFilterCount > 0"
                      data-cy="sort-filter-count"
                      >({{ sortFilterCount }})</span
                    >
                  </span>
                </ion-button>
                <ion-button
                  class="usf-green-link-button"
                  (click)="clearReservedSort()"
                >
                  {{ 'i18n.common.clearAll' | translate }}
                </ion-button>
              </div>
            </div>
          </div>
          <!-- Autosubbed products -->
          <ion-row *ngIf="substituteProducts?.length > 0">
            <ng-container>
              <ion-col
                size-xl="12"
                size-l="12"
                size-md="12"
                size-s="12"
                size-xs="12"
              >
                <div class="submitted-order-title">
                  <h2 data-cy="submitted-order-title-text">
                    {{ 'i18n.orderSubmittedPage.autoSubDetails' | translate }}
                  </h2>
                </div>
              </ion-col>
            </ng-container>
            <ion-col
              size-xl="12"
              size-l="12"
              size-md="12"
              size-s="12"
              size-xs="12"
            >
              <div
                *ngFor="let item of substituteProducts; last as lastItem; index as i;"
              >
                <app-order-submitted-item-card
                  [item]="item"
                  [subbedItem]="item.substituteFlag === 'A' ? autoSubItem(item?.substituteFor) : null"
                  [productSummary]="submittedOrderVm.products?.get(item?.productNumber)?.summary"
                  [subbedProductSummary]="submittedOrderVm.autoSubItems?.get(item?.substituteFor)?.productSummary"
                  [lastItem]="lastItem"
                  [displayTags]="submittedOrderVm.displayTags?.get(item?.productNumber)"
                  [availableToPromise]="submittedOrderVm?.showAvailableToPromise"
                ></app-order-submitted-item-card>
              </div>
            </ion-col>
          </ion-row>
          <!-- Order products -->
          <ion-row>
            <ng-container>
              <ion-col
                size-xl="12"
                size-l="12"
                size-md="12"
                size-s="12"
                size-xs="12"
              >
                <div
                  *ngIf="filteredOrderItems$ | async as filteredOrderItems"
                  class="submitted-order-title"
                  data-cy="submitted-order-title-text"
                >
                  <h2>
                    {{filteredOrderItems?.length}} {{
                    'i18n.orderSubmittedPage.product' | translate }}{{
                    filteredOrderItems?.length === 1 ? '' : 's' }}
                  </h2>
                  <!-- <h3>
                    <ng-container *ngIf="this.submittedOrderVm?.isEditable">
                      <span>
                        <ion-button
                          class="usf-fill-green-button"
                          (click)="editSubmittedOrder()"
                          data-cy="edit-submitted-order-button"
                          id="edit-order-link"
                        >
                          {{ 'i18n.orderPage.modifyOrder' | translate }}
                        </ion-button>
                      </span>
                    </ng-container>
                    < !-- Hide Copy link until implemented -- >
                    < !-- <span class="border">|</span>
                      <span>Copy</span> -- >

                    <span *ngIf="this.submittedOrderVm?.isCancellable">
                      <ion-button
                        class="usf-outline-orange-button"
                        (click)="cancelOrderModal()"
                        data-cy="cancel-submitted-order-button"
                        id="cancel-order-link"
                      >
                        {{ 'i18n.orderPage.cancelOrder' | translate }}
                      </ion-button>
                    </span>
                  </h3> -->
                </div>
              </ion-col>
            </ng-container>
            <ion-col
              size-xl="12"
              size-l="12"
              size-md="12"
              size-s="12"
              size-xs="12"
            >
              <!-- Vendor ship order items -->

              <ng-container
                *ngIf="submittedOrderVm?.submittedOrderById?.orderItems && submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'VS' && orderTrackingGroups$ | async as orderTrackingGroups"
              >
                <ion-accordion-group
                  *ngFor="let trackingGroup of orderTrackingGroups | keyvalue"
                  (ionChange)="accordionGroupChange($event, trackingGroup.key)"
                  value="accordionRow"
                >
                  <ion-accordion value="accordionRow">
                    <ion-item slot="header" color="light">
                      <div class="expandable-panel-header">
                        <div>
                          <ion-icon
                            name="{{
                        this.closedPanels.indexOf(trackingGroup.key) > -1 ? 'chevron-forward-outline' : 'chevron-down-outline'
                        }}"
                          ></ion-icon>
                        </div>
                        <div class="expandable-panel-header">
                          <div
                            class="expandable-panel-header-label"
                            data-cy="submitted-order-estimated-delivery-label"
                          >
                            {{ 'i18n.orderSubmittedPage.estimatedDelivery' |
                            translate }}
                            <span
                              data-cy="submitted-order-estimated-delivery-text"
                              >{{
                              submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus
                              === orderStatusEnum.ORDER_CANCELLED ? "N/A" :
                              orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.estimatedDeliveryDate
                              ?
                              (orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.estimatedDeliveryDate
                              | date: "MM/dd/yyyy") :
                              'i18n.orderSubmittedPage.comingSoon' | translate
                              }}</span
                            >
                          </div>
                          <div
                            class="expandable-panel-header-label"
                            data-cy="submitted-order-tracking-carrier-code-label"
                          >
                            {{ 'i18n.orderSubmittedPage.carrier' | translate }}
                            <span
                              data-cy="submitted-order-tracking-carrier-code-text"
                              >{{
                              submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus
                              === orderStatusEnum.ORDER_CANCELLED ? "N/A" : (
                              orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode
                              === 'FEDEX' ? 'FedEx' : (
                              (orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode
                              === '' ||
                              !orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode)
                              ? (!trackingGroup.key ?
                              ('i18n.orderSubmittedPage.comingSoon' | translate)
                              : 'N/A') :
                              orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode
                              ) ) }}</span
                            >
                          </div>
                          <div
                            class="expandable-panel-header-label"
                            data-cy="submitted-order-header-tracking-label"
                          >
                            {{ 'i18n.orderSubmittedPage.tracking' | translate }}
                            <a
                              [ngClass]="{'tracking-link': submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED, 'cancelled-tracking': submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus === orderStatusEnum.ORDER_CANCELLED}"
                              *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED && orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode && orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode !== ''"
                              (click)="$event.stopPropagation(); openTrackingInfo({ trackingNumber: trackingGroup.key, carrierCode: orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode})"
                              >{{ trackingGroup.key ? trackingGroup.key : '' }}
                              <ion-icon
                                *ngIf="trackingGroup.key"
                                src="assets/icon/external-link.svg"
                              ></ion-icon
                            ></a>
                            <span
                              *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus === orderStatusEnum.ORDER_CANCELLED"
                              data-cy="order-submitted-cancelled-tracking"
                              >N/A</span
                            >
                            <span
                              *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED && (!orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode || orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode === '')"
                              data-cy="order-submitted-coming-soon-label"
                              >{{ trackingGroup.key ? trackingGroup.key :
                              ('i18n.orderSubmittedPage.comingSoon' | translate)
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </ion-item>
                    <div slot="content">
                      <ng-container
                        *ngIf="orderTrackingGroups[trackingGroup.key]?.length > 0; else noResultsFound"
                      >
                        <div
                          *ngFor="let trackingItem of orderTrackingGroups[trackingGroup.key]; last as lastItem; index as i"
                        >
                          <app-order-submitted-item-card
                            [item]="trackingItem?.orderItem"
                            [productSummary]="submittedOrderVm?.products?.get(trackingItem?.orderItem?.productNumber)?.summary"
                            [lastItem]="lastItem"
                            [displayTags]="submittedOrderVm?.displayTags?.get(trackingItem?.orderItem?.productNumber)"
                            [trackingNumber]="trackingItem?.orderTracking?.trackingNumber?.includes('|') ? trackingItem?.orderTracking?.trackingNumber : null"
                            [carrierCode]="orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode"
                            [availableToPromise]="submittedOrderVm?.showAvailableToPromise"
                            (openTrackingInfo)="openTrackingInfo($event)"
                          ></app-order-submitted-item-card>
                        </div>
                      </ng-container>
                      <ng-template #noResultsFound>
                        <div class="no-result-found-card-mobile">
                          <ion-card>
                            <ion-card-content class="no-result-found-text">
                              {{'i18n.orderPage.noProductsWereFound' |
                              translate}}
                            </ion-card-content>
                          </ion-card>
                        </div>
                      </ng-template>
                    </div>
                  </ion-accordion>
                </ion-accordion-group>
              </ng-container>
              <!-- Router order items -->
              <div>
                <ng-container
                  *ngIf="filteredOrderItems$ | async as filteredOrderItems"
                >
                  <ng-container
                    *ngIf="(submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'RT' ||
                  submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'WC' ||
                  submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'CC')"
                  >
                    <ng-container
                      *ngIf="filteredOrderItems?.length > 0; else noResultsFound"
                    >
                      <div
                        *ngFor="let item of filteredOrderItems; last as lastItem; index as i"
                      >
                        <app-order-submitted-item-card
                          [item]="item"
                          [productSummary]="submittedOrderVm?.products?.get(item?.productNumber)?.summary"
                          [lastItem]="lastItem"
                          [availableToPromise]="submittedOrderVm?.showAvailableToPromise"
                          [displayTags]="submittedOrderVm?.displayTags?.get(item?.productNumber)"
                        ></app-order-submitted-item-card>
                      </div>
                    </ng-container>
                    <ng-template #noResultsFound>
                      <div class="no-result-found-card-mobile">
                        <ion-card>
                          <ion-card-content class="no-result-found-text">
                            {{'i18n.orderPage.noProductsWereFound' | translate}}
                          </ion-card-content>
                        </ion-card>
                      </div>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
    <!--------- Mobile section------->
    <div id="mobile">
      <div class="top-section-background">
        <ion-grid [fixed]="true">
          <ion-row class="mobile-info-header">
            <ion-col>
              <ion-row>
                <ion-col size="11">
                  <h1 data-cy="submitted-order-page-title">
                    {{ 'i18n.orderSubmittedPage.orderNum' | translate }}{{
                    submittedOrderVm?.submittedOrderById?.orderHeader?.tandemOrderNumber
                    }}
                  </h1>
                </ion-col>
                <ng-container
                  *appShowSplit="[orderDetailsDownloadButtonFeatureFlag]"
                >
                  <ion-col size="1">
                    <ion-icon
                      *ngIf="((willCallInFlight$ | async) === false) && ((shipToInFlight$ | async) === false)"
                      class="additional-info-ellipsis"
                      data-cy="additional-info-ellipsis-icon"
                      name="ellipsis-vertical-circle-sharp"
                      (click)="showSubmittedOrderActionSheet(true)"
                    ></ion-icon>
                  </ion-col>
                </ng-container>
              </ion-row>

              <!-- order action buttons -->
              <app-order-status-info
                [orderHeader]="submittedOrderVm?.submittedOrderById?.orderHeader"
                [orderItems]="submittedOrderVm?.submittedOrderById?.orderItems"
                [title]="submittedOrderVm?.displayTitle"
                [icon]="orderStatusDetails?.icon"
                [restrictToOG]="submittedOrderVm?.restrictToOG"
                [orderStatusDetails]="orderStatusDetails"
              ></app-order-status-info>

              <!-- order date -->
              <h4>
                <app-orders-list-delivered
                  *ngIf="
                  submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'VS' &&
                  submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus ===
                  orderStatusEnum.DELIVERED &&
                    !!submittedOrderVm?.submittedOrderById?.orderHeader?.confirmedDeliveryDate
                  "
                  [orderHeader]="submittedOrderVm?.submittedOrderById?.orderHeader"
                  class="delivery-date"
                ></app-orders-list-delivered>
              </h4>
              <h4
                *ngIf="((!submittedOrderVm?.submittedOrderById?.orderHeader?.deliveredDtm && !!submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered) &&
                !!submittedOrderVm?.submittedOrderById?.orderHeader?.etaRoute) && !(hideEtaGlobalFeatureFlag && submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta
                 )"
                data-cy="submitted-order-delivered-text"
                class="delivery-date"
              >
                {{ 'i18n.orderPage.arrivedToday' | translate }}
              </h4>

              <h4
                *ngIf="!!submittedOrderVm?.submittedOrderById?.orderHeader?.deliveredDtm &&
                        !!submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered &&
                        (
                          hideEtaGlobalFeatureFlag &&
                          submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta
                        )
                        "
                data-cy="submitted-order-delivered-text"
                class="delivery-date"
              >
                <ng-container
                  *ngIf="((willCallInFlight$ | async) === false) ; else spinner"
                >
                  {{ 'i18n.orderSubmittedPage.expectedBy' | translate }}
                  <ng-container
                    *ngIf="
                                ((willCallInFlight$ | async) === false)  &&
                                  (submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'RT' ||
                                    submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'WC');
                                else spinner
                              "
                  >
                    <ng-container
                      *ngIf="platformService?.platformEnum?.mobile;"
                    >
                      {{
                      submittedOrderVm?.submittedOrderById?.orderHeader?.confirmedDeliveryDate
                      | date: 'M/d/yyyy':'GMT' }}
                    </ng-container>
                  </ng-container>
                </ng-container>
              </h4>
              <h4
                class="order-delivery submitted-order-wmt-eta-text"
                data-cy="submitted-order-wmt-eta-text"
                *ngIf="(!submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered &&
                submittedOrderVm?.submittedOrderById?.orderHeader?.deliveryEta &&
                isValidDate( submittedOrderVm?.submittedOrderById?.orderHeader?.deliveryEta) && hasETADetails) &&
                !(hideEtaGlobalFeatureFlag && submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta ); else hideEtaRange"
              >
                {{ 'i18n.orderPage.WMTeta1' | translate }}
                {{submittedOrderVm?.submittedOrderById?.orderHeader?.deliveryEta
                | date: 'M/d': customerTimeZone }} {{ 'i18n.orderPage.WMTeta2' |
                translate }} {{
                submittedOrderVm?.submittedOrderById?.orderHeader?.etaRangeMinimum
                | timezoneDate: 'h:mm a':customerTimeZone }} - {{
                submittedOrderVm?.submittedOrderById?.orderHeader?.etaRangeMaximum
                | timezoneDate: 'h:mm a':customerTimeZone:true }}
                <p
                  *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.etaMessageType === orderETAMessageType.PLANNED"
                  class="planned-text"
                >
                  {{ 'i18n.orderSubmittedPage.etaPlanned' | translate }}
                </p>
              </h4>

              <ng-template #hideEtaRange>
                <h4
                  *ngIf="(!submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered &&
                  !hasETADetails &&
                  submittedOrderVm?.submittedOrderById?.orderHeader?.deliveryEta &&
                  isValidDate( submittedOrderVm?.submittedOrderById?.orderHeader?.deliveryEta)) &&
                  !(hideEtaGlobalFeatureFlag && submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta)"
                  class="order-delivery submitted-order-wmt-eta-text"
                  data-cy="submitted-order-wmt-eta-text"
                >
                  {{ 'i18n.orderPage.WMTeta1' | translate }}
                  {{submittedOrderVm?.submittedOrderById?.orderHeader?.deliveryEta
                  | date: 'M/d': customerTimeZone }}
                  <p
                    *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.etaMessageType === orderETAMessageType.PLANNED"
                    class="planned-text"
                  >
                    {{ 'i18n.orderSubmittedPage.etaPlanned' | translate }}
                  </p>
                </h4>
              </ng-template>

              <h4
                data-cy="submitted-order-delivery-eta-text"
                *ngIf="!!submittedOrderVm?.submittedOrderById?.orderHeader?.deliveredDtm &&
                        !!submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered &&
                        !(hideEtaGlobalFeatureFlag && submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta)"
              >
                {{ 'i18n.orderPage.actualDeliveryDate' | translate }} {{
                actualDeliveryDate | date: 'M/d/yyyy' }} at {{actualDeliveryDate
                | date: 'shortTime' }} {{ this.customerTimeZone ?
                this.customerTimeZone : 'CT' }}
              </h4>

              <h4
                *ngIf=" (!(submittedOrderVm?.submittedOrderById?.orderHeader?.deliveryEta && isValidDate(submittedOrderVm?.submittedOrderById?.orderHeader?.deliveryEta)) ||
                (hideEtaGlobalFeatureFlag && submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta)) &&
                !submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered"
              >
                <span
                  data-cy="submitted-order-vendor-eta-text"
                  [hidden]="submittedOrderVm?.submittedOrderById?.orderHeader?.confirmedDeliveryDate &&
                            submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus === orderStatusEnum.DELIVERED &&
                            submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'VS'"
                  *ngIf="(submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'VS' &&
                     submittedOrderVm?.submittedOrderById?.orderHeader?.orderStatus !==
                        orderStatusEnum.ORDER_CANCELLED &&
                        submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !==
                        orderStatusEnum.DELIVERED &&
                   !(!!submittedOrderVm?.submittedOrderById?.orderHeader?.orderTracking?.length ||
                  submittedOrderVm?.submittedOrderById?.orderHeader?.trackingAvailable)) ||
                  (submittedOrderVm?.orderStatusDisplayEnabled &&
                  submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'VS') ||
                  (submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'VS' &&
                  submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !==
                  orderStatusEnum.DELIVERED &&
                    !submittedOrderVm?.submittedOrderById?.orderHeader?.confirmedDeliveryDate); else deliveryDateHandle"
                >
                  {{ 'i18n.orderSubmittedPage.expectedBy' | translate }}
                  <ng-container
                    *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED; else cancelledMobileOrder"
                  >
                    {{submittedOrderVm?.submittedOrderById?.orderHeader?.confirmedDeliveryDate
                    | date: 'M/d/yyyy':'GMT' }}
                  </ng-container>
                  <ng-template #cancelledMobileOrder> N/A </ng-template>
                </span>
              </h4>

              <div
                *ngIf="(!!submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered && !!submittedOrderVm?.submittedOrderById?.orderHeader?.etaRoute) &&
                 !(hideEtaGlobalFeatureFlag && submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta)
                "
                class="route-number"
                data-cy="route-number"
              >
                Route:
                {{submittedOrderVm?.submittedOrderById?.orderHeader?.etaRoute}}
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <!------- Start: Google map Mobile ------->

              <div
                [hidden]="!orderHasDeliveryDetails"
                *ngIf="((!submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered && submittedOrderVm?.submittedOrderById?.orderHeader?.orderDelivered !== null) &&
                        isAllCoordinatesValid && submittedOrderVm?.submittedOrderById?.orderHeader?.etaMessageType === orderETAMessageType.ETA) &&
                         !(hideEtaGlobalFeatureFlag && submittedOrderVm?.submittedOrderById?.orderHeader?.hideEta)"
              >
                <div
                  data-cy="wmt-mobile-map-section"
                  #map
                  class="map"
                  *ngIf="this.platformService?.platformType === this.platformService?.platformEnum?.mobile"
                ></div>
                <div data-cy="wmt-mobile-disclosure-text" class="note-map">
                  {{ 'i18n.orderPage.WMTnote' | translate }}
                </div>
              </div>

              <!------- /End: Google map ------->
            </ion-col>
          </ion-row>
          <div class="order-info-section">
            <app-submitted-order-info-card
              [products]="submittedOrderVm?.products"
              [isOnline$]="panAppState.online$"
              [displayTitle]="submittedOrderVm?.displayTitle"
              [orderHeader]="submittedOrderVm?.submittedOrderById?.orderHeader"
              [orderItems]="submittedOrderVm?.submittedOrderById?.orderItems"
              [tallies]="submittedOrderVm?.tallies"
              [customer]="customer$ | async"
              [orderStatusDetails]="orderStatusDetails"
              [deliveryETA]="deliveryETA"
              [isInternalUser]="isInternalUser"
              [restrictToOG]="submittedOrderVm?.restrictToOG"
              [isDealsAvailable]="isDealsAvailable"
              [willCallInFlight]="willCallInFlight$ | async"
              [customerTimeZone]="this.customerTimeZone"
              [autoSubItems]="submittedOrderVm?.autoSubItems"
              [isEditable]="submittedOrderVm?.isEditable"
              [isCancellable]="submittedOrderVm?.isCancellable"
              [shipToCustomer]="submittedOrderVm?.shipToCustomer || (superUserShipToCustomer$ | async)  "
              [shipToDepartmentName]="submittedOrderVm?.shipToDepartmentName || getShipToDepartmentName((superUserShipToCustomer$ | async), submittedOrderVm?.submittedOrderById?.orderHeader?.shipToDepartment) "
              [shipToInFlight]="shipToInFlight$ | async"
              (downloadModalOpenEmitter)="showDownloadOrderModal(true)"
              (downloadFileEmmitter)="handleDownloadOrder($event)"
              (printOrderEmitter)="printOrderEmitterHandler()"
              (shareOrderEmitter)="shareOrderEmitterHandler()"
              (editSubmittedOrderEmitter)="editSubmittedOrder()"
              (transferModalEmitter)="transferModal()"
              (cancelOrderModalEmitter)="cancelOrderModal()"
              (shipToModalOpenEmitter)="showShipToModal(true)"
              (willCallModalOpenEmitter)="openWillCallModal()"
              (recoveryModalOpenEmitter)="showRecoveryModal(true)"
              [platformType]="platformService?.platformEnum.mobile"
              [showTransferButton]="submittedOrderVm?.showTransferButton"
              [transferButtonText]="submittedOrderVm?.transferButtonText"
              [modifyButtonText]="submittedOrderVm?.modifyButtonText"
              [orderStatusDisplayEnabled]="submittedOrderVm?.orderStatusDisplayEnabled"
              [customersWithTheSameDivision]="submittedOrderVm?.customersWithTheSameDivision"
              [isProntoDeliveryCustomer]="isProntoDeliveryDate || isSuperUserProntoCustomer"
            ></app-submitted-order-info-card>
          </div>
        </ion-grid>
      </div>
      <div class="bottom-section-background">
        <ion-grid [fixed]="true">
          <ion-row>
            <ion-col
              size-xl="12"
              size-l="12"
              size-md="12"
              size-s="12"
              size-xs="12"
            >
              <app-deals-banner
                [bannerStyle]="bannerStyle"
                [buttonLink]="dealsUrl"
              >
              </app-deals-banner>
            </ion-col>
          </ion-row>
        </ion-grid>
        <div
          data-cy="order-details-search-sort-filter-section"
          class="search-sort-filter-section"
          *appShowSplit="[orderDetailsSearchFeatureFlag]"
        >
          <div class="search-container">
            <ion-searchbar
              id="list-search-bar-0"
              data-cy="list-detail-searchbar"
              class="search"
              mode="md"
              placeholder="{{ 'i18n.orderSubmittedPage.searchWithinOrder' | translate}}"
              [ngModel]="searchKey | async"
              (ionInput)="orderItemSearch($event)"
            >
            </ion-searchbar>
          </div>
          <div>
            <div
              class="sort-button-and-reset"
              *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader.orderType !== 'VS'"
            >
              <ion-button
                data-cy="sort-filter-button"
                class="usf-outline-green-button sort-button mobile-width"
                (click)="showSortModal(true)"
              >
                <ion-icon
                  data-cy="sort-filter-button-icon"
                  slot="start"
                  name="filter"
                ></ion-icon>
                <span data-cy="sort-filter-button-text">
                  {{ 'i18n.lists.sortAndFilter' | translate }}
                  <span *ngIf="sortFilterCount > 0" data-cy="sort-filter-count"
                    >({{ sortFilterCount }})</span
                  >
                </span>
              </ion-button>
              <ion-button
                class="usf-green-link-button"
                (click)="clearReservedSort()"
              >
                {{ 'i18n.common.clearAll' | translate }}
              </ion-button>
            </div>
          </div>
        </div>
        <ion-grid [fixed]="true">
          <!-- Autosubbed products -->
          <ion-row *ngIf="substituteProducts?.length > 0">
            <ng-container>
              <ion-col
                size-xl="12"
                size-l="12"
                size-md="12"
                size-s="12"
                size-xs="12"
              >
                <div class="submitted-order-title">
                  <h2 data-cy="submitted-order-title-text">
                    {{ 'i18n.orderSubmittedPage.autoSubDetails' | translate }}
                  </h2>
                </div>
              </ion-col>
            </ng-container>
            <ion-col
              size-xl="12"
              size-l="12"
              size-md="12"
              size-s="12"
              size-xs="12"
            >
              <div
                *ngFor="let item of substituteProducts; last as lastItem; index as i;"
              >
                <app-order-submitted-item-card
                  [item]="item"
                  [subbedItem]="item.substituteFlag === 'A' ? autoSubItem(item?.substituteFor) : null"
                  [productSummary]="submittedOrderVm.products?.get(item?.productNumber)?.summary"
                  [subbedProductSummary]="submittedOrderVm.autoSubItems?.get(item?.substituteFor)?.productSummary"
                  [lastItem]="lastItem"
                  [displayTags]="submittedOrderVm.displayTags?.get(item?.productNumber)"
                  [availableToPromise]="submittedOrderVm?.showAvailableToPromise"
                ></app-order-submitted-item-card>
              </div>
            </ion-col>
          </ion-row>

          <!-- Order products -->
          <ion-row>
            <ng-container>
              <ion-col
                size-xl="12"
                size-l="12"
                size-md="12"
                size-s="12"
                size-xs="12"
              >
                <div
                  *ngIf="filteredOrderItems$ | async as filteredOrderItems"
                  class="submitted-order-title"
                  data-cy="submitted-order-title-text"
                >
                  <h2>
                    {{filteredOrderItems?.length}} {{
                    'i18n.orderSubmittedPage.product' | translate }}{{
                    filteredOrderItems?.length === 1 ? '' : 's' }}
                  </h2>
                  <!-- <div>
                    <ng-container *ngIf="this.submittedOrderVm?.isEditable">
                      <span>
                        <ion-button
                          class="usf-fill-green-button mobile-submitted-button-size"
                          data-cy="edit-submitted-order-button"
                          (click)="editSubmittedOrder()"
                        >
                          {{ 'i18n.common.modify' | translate }}
                        </ion-button>
                      </span>
                    </ng-container>
                    <! -- Hide Copy link until implemented -->
                  <!-- <span class="border">|</span>
                      <span>Copy</span> -- >

                    <span *ngIf="this.submittedOrderVm?.isCancellable">
                      <ion-button
                        id="cancel-order-link"
                        class="usf-outline-orange-button mobile-submitted-button-size"
                        data-cy="cancel-submitted-order-button"
                        (click)="cancelOrderModal()"
                      >
                        {{ 'i18n.common.cancel' | translate }}
                      </ion-button>
                    </span>
                  </div> -->
                </div>
              </ion-col>
            </ng-container>
            <ion-col
              size-xl="12"
              size-l="12"
              size-md="12"
              size-s="12"
              size-xs="12"
            >
              <!-- Vendor ship order items -->
              <ng-container
                *ngIf="submittedOrderVm?.submittedOrderById?.orderItems && submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'VS' && orderTrackingGroups$ | async as orderTrackingGroups"
              >
                <ion-accordion-group
                  *ngFor="let trackingGroup of orderTrackingGroups | keyvalue"
                  (ionChange)="accordionGroupChange($event, trackingGroup.key)"
                  value="accordionRow"
                >
                  <ion-accordion value="accordionRow">
                    <ion-item slot="header" color="light">
                      <div class="expandable-panel-header">
                        <div>
                          <ion-icon
                            name="{{
                        this.closedPanels.indexOf(trackingGroup.key) > -1 ? 'chevron-forward-outline' : 'chevron-down-outline'
                        }}"
                          ></ion-icon>
                        </div>
                        <div>
                          <div
                            class="expandable-panel-header-label"
                            data-cy="submitted-order-estimated-delivery-label"
                          >
                            {{ 'i18n.orderSubmittedPage.estimatedDelivery' |
                            translate }}
                            <span
                              data-cy="submitted-order-estimated-delivery-text"
                              >{{
                              submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus
                              === orderStatusEnum.ORDER_CANCELLED ? "N/A" :
                              orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.estimatedDeliveryDate
                              ?
                              (orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.estimatedDeliveryDate
                              | date: "MM/dd/yyyy") :
                              'i18n.orderSubmittedPage.comingSoon' | translate
                              }}</span
                            >
                          </div>
                          <div
                            class="expandable-panel-header-label"
                            data-cy="submitted-order-tracking-carrier-code-label"
                          >
                            {{ 'i18n.orderSubmittedPage.carrier' | translate }}
                            <span
                              data-cy="submitted-order-tracking-carrier-code-text"
                              >{{
                              submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus
                              === orderStatusEnum.ORDER_CANCELLED ? "N/A" : (
                              orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode
                              === 'FEDEX' ? 'FedEx' : (
                              (orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode
                              === '' ||
                              !orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode)
                              ? (!trackingGroup.key ?
                              ('i18n.orderSubmittedPage.comingSoon' | translate)
                              : 'N/A') :
                              orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode
                              ) ) }}</span
                            >
                          </div>
                          <div
                            class="expandable-panel-header-label"
                            data-cy="submitted-order-header-tracking-label"
                          >
                            {{ 'i18n.orderSubmittedPage.tracking' | translate }}
                            <a
                              [ngClass]="{'tracking-link': submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED, 'cancelled-tracking': submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus === orderStatusEnum.ORDER_CANCELLED}"
                              *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED && orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode && orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode !== ''"
                              (click)="$event.stopPropagation(); openTrackingInfo({ trackingNumber: trackingGroup.key, carrierCode: orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode})"
                              >{{ trackingGroup.key ? trackingGroup.key : '' }}
                              <ion-icon
                                *ngIf="trackingGroup.key"
                                src="assets/icon/external-link.svg"
                              ></ion-icon
                            ></a>
                            <span
                              *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus === orderStatusEnum.ORDER_CANCELLED"
                              data-cy="order-submitted-cancelled-tracking"
                              >N/A</span
                            >
                            <span
                              *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED && (!orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode || orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode === '')"
                              data-cy="order-submitted-coming-soon-label"
                              >{{ trackingGroup.key ? trackingGroup.key :
                              ('i18n.orderSubmittedPage.comingSoon' | translate)
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </ion-item>
                    <div slot="content">
                      <ng-container
                        *ngIf="orderTrackingGroups[trackingGroup.key]?.length > 0; else noResultsFound"
                      >
                        <div
                          *ngFor="let trackingItem of orderTrackingGroups[trackingGroup.key]; last as lastItem; index as i"
                        >
                          <app-order-submitted-item-card
                            [item]="trackingItem?.orderItem"
                            [productSummary]="submittedOrderVm?.products?.get(trackingItem?.orderItem?.productNumber)?.summary"
                            [lastItem]="lastItem"
                            [displayTags]="submittedOrderVm?.displayTags?.get(trackingItem?.orderItem?.productNumber)"
                            [trackingNumber]="trackingItem?.orderTracking?.trackingNumber?.includes('|') ? trackingItem?.orderTracking?.trackingNumber : null"
                            [carrierCode]="orderTrackingGroups[trackingGroup.key][0]?.orderTracking?.carrierCode"
                            [availableToPromise]="submittedOrderVm?.showAvailableToPromise"
                            (openTrackingInfo)="openTrackingInfo($event)"
                          ></app-order-submitted-item-card>
                        </div>
                      </ng-container>
                      <ng-template #noResultsFound>
                        <div class="no-result-found-card-mobile">
                          <ion-card>
                            <ion-card-content class="no-result-found-text">
                              {{'i18n.orderPage.noProductsWereFound' |
                              translate}}
                            </ion-card-content>
                          </ion-card>
                        </div>
                      </ng-template>
                    </div>
                  </ion-accordion>
                </ion-accordion-group>
              </ng-container>
              <!-- Router order items -->
              <div>
                <ng-container
                  *ngIf="filteredOrderItems$ | async as filteredOrderItems"
                >
                  <ng-container
                    *ngIf="(submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'RT' ||
                  submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'WC' ||
                  submittedOrderVm?.submittedOrderById?.orderHeader.orderType === 'CC')"
                  >
                    <ng-container
                      *ngIf="filteredOrderItems?.length > 0; else noResultsFound"
                    >
                      <div
                        *ngFor="let item of filteredOrderItems; last as lastItem; index as i;"
                      >
                        <app-order-submitted-item-card
                          [item]="item"
                          [productSummary]="submittedOrderVm?.products?.get(item?.productNumber)?.summary"
                          [lastItem]="lastItem"
                          [availableToPromise]="submittedOrderVm?.showAvailableToPromise"
                          [displayTags]="submittedOrderVm?.displayTags?.get(item?.productNumber)"
                        ></app-order-submitted-item-card>
                      </div>
                    </ng-container>
                    <ng-template #noResultsFound>
                      <div class="no-result-found-card-mobile">
                        <ion-card>
                          <ion-card-content class="no-result-found-text">
                            {{'i18n.orderPage.noProductsWereFound' | translate}}
                          </ion-card-content>
                        </ion-card>
                      </div>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>

  <ng-template #deliveryDateHandle>
    <!--Scheduled Date-->
    <ng-container
      *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'WC'; else routedOrderDate"
    >
      <ng-container *appShowSplit="[convertToWillCallFeatureFlag]">
        <ng-container *ngIf="!hasETADetails">
          {{ 'i18n.orderPage.willCallPickUpDate' | translate }}:
          <ng-container
            *ngIf="!submittedOrderVm?.willCallInFlight; else spinner"
          >
            {{
            submittedOrderVm?.submittedOrderById?.orderHeader?.willCallDateTime
            | date: 'EEEE, M/d':'GMT' }} at {{
            submittedOrderVm?.submittedOrderById?.orderHeader?.willCallDateTime
            | date: 'h:mm a':'GMT' | lowercase }}
          </ng-container>
        </ng-container>

        <ng-container *ngIf="hasETADetails">
          <ng-container>
            {{
            submittedOrderVm?.submittedOrderById?.orderHeader?.confirmedDeliveryDate
            | date: 'M/d/yyyy':'GMT' }}
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #routedOrderDate>
    <ng-container
      *ngIf="submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'RT' ||
      submittedOrderVm?.submittedOrderById?.orderHeader?.orderType === 'CC';"
    >
      <ng-container *ngIf="!submittedOrderVm?.willCallInFlight ; else spinner">
        <div class="expected-by">
          <span *ngIf="(shipToInFlight$ | async) === false; else spinner">
            {{ 'i18n.orderSubmittedPage.expectedBy' | translate }} {{
            submittedOrderVm?.submittedOrderById?.orderHeader?.confirmedDeliveryDate
            | date: 'M/d/yyyy':'GMT' }}</span
          >
        </div>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #spinner>
    <ion-spinner name="circles" class="order-spinner"></ion-spinner>
  </ng-template>
  <ion-action-sheet
    class="action-sheet-touch"
    mode="ios"
    [isOpen]="showSubmittedOrderActionSheet$ | async"
    (didDismiss)="showSubmittedOrderActionSheet(false)"
    [buttons]="constructDownloadOrderButton()"
  ></ion-action-sheet>
</ion-content>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-lg'"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum?.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="showDownloadOrderModal$ | async"
  (ionModalDidDismiss)="showDownloadOrderModal(false)"
>
  <ng-template>
    <app-download-order-modal
      class="ion-page"
      [orders]="[submittedOrderVm?.submittedOrderById]"
      [platform]="platformService?.platformType"
      (dismissEvent)="showDownloadOrderModal(false)"
      (downloadOrdersEmitter)="handleDownloadOrder($event)"
    >
    </app-download-order-modal>
  </ng-template>
</ion-modal>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-lg'"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum?.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="showSortModal$ | async"
  (ionModalDidDismiss)="closeSortModal($event)"
>
  <ng-template>
    <app-sort-product-modal
      class="ion-page"
      [sortDirection]="sortByReserved | async"
      [filterSelection]="filterSelection | async"
    ></app-sort-product-modal>
  </ng-template>
</ion-modal>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-xl'"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum?.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="showShipToModal$ | async"
  (ionModalDidDismiss)="dismissShipToModal($event)"
>
  <ng-template>
    <app-ship-to-modal
      class="ion-page"
      [initialDeliveryDateForOrder]="submittedOrderVm?.submittedOrderById?.orderHeader?.confirmedDeliveryDate"
      [customers]="(loadCustomersByDivision() | async)"
      [currentCustomer]="submittedOrderVm?.selectedCustomer"
      [currentShipToCustomerNumber]="submittedOrderVm?.submittedOrderById?.orderHeader?.shipToCustomer || submittedOrderVm?.submittedOrderById?.orderHeader?.customerNumber"
      [currentShipToDepartmentNumber]="submittedOrderVm?.submittedOrderById?.orderHeader?.shipToDepartment  || submittedOrderVm?.submittedOrderById?.orderHeader?.departmentNumber"
      [currentPurchaseOrderNumber]="submittedOrderVm?.submittedOrderById?.orderHeader?.purchaseOrderNumber"
      [isSuperUser]="(isSuperUser$() | async)"
    ></app-ship-to-modal>
  </ng-template>
</ion-modal>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-xl'"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum?.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="showWillCallModal$ | async"
  (ionModalDidDismiss)="dismissWillCallModal($event)"
>
  <ng-template>
    <app-will-call-modal
      class="ion-page"
      [orderHeader]="submittedOrderVm?.submittedOrderById?.orderHeader"
      [orderItems]="submittedOrderVm?.submittedOrderById?.orderItems"
      [customer]="customer$ | async"
      [isOnline$]="panAppState.online$"
      (dismissEvent)="dismissWillCallModal($event)"
      (submitEvent)="confirmWillCall($event)"
      (cancelEvent)="cancelWillCallModal($event)"
    ></app-will-call-modal>
  </ng-template>
</ion-modal>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-lg'"
  [initialBreakpoint]="platformService?.platformType !== platformService?.platformEnum?.desktop ? 1 : undefined"
  [breakpoints]="platformService?.platformType !== platformService?.platformEnum?.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="showRecoveryModal$ | async"
  (ionModalDidDismiss)="dismissRecoveryModal($event)"
>
  <ng-template>
    <app-recovery-order-modal
      class="ion-page"
      [platform]="platformService?.platformType"
      [orderNumber]="submittedOrderVm?.submittedOrderById?.orderHeader?.tandemOrderNumber"
      [showEmail]="showEmail$ | async"
      (dismissEvent)="dismissRecoveryModal(false)"
      [issueOptions]="issueOptions$ | async"
      (submitEvent)="submitRecoveryOrder($event)"
    ></app-recovery-order-modal>
  </ng-template>
</ion-modal>
